
export default {
    name: 'LeeRadioGroup',
    inheritAttrs:false,
    data() {
        return {
        };
    },
    provide() {
        return {
            radio: this
        };
    },
    props: {
        value:{
            type:Number,
            default:1
        },
        size:{
            type:String,
            default:'s'
        },
        type:{
            type:String,
            default:''
        }
    },
    computed: {
        
    }
};
